import axios from 'axios';

// Deliberately a SEPARATE client from services/apiClient.js — a Platform
// Admin token must never be attached to a company API call, or vice versa
// (the backend also enforces this independently; see middleware/auth.js
// and middleware/platformAdminAuth.js). Kept in memory only, same as the
// main app's access token, so a refresh of the page requires signing back
// in rather than a raw JWT sitting in localStorage/sessionStorage.
const platformAdminApiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api/v1',
});

let platformAdminToken = null;

export function setPlatformAdminToken(token) {
  platformAdminToken = token;
}

export function getPlatformAdminToken() {
  return platformAdminToken;
}

platformAdminApiClient.interceptors.request.use((config) => {
  if (platformAdminToken) {
    config.headers.Authorization = `Bearer ${platformAdminToken}`;
  }
  return config;
});

platformAdminApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.data && error.response.data.error) {
      return Promise.reject(error.response.data.error);
    }
    return Promise.reject({ code: 'NETWORK_ERROR', message: 'Unable to reach the server.' });
  },
);

export default platformAdminApiClient;
